
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSleetShowersPolartwilightColour as ObiSleetShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sleet-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiSleetShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-sleet-showers-polartwilight-colour',
   elementClass: ObiSleetShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 